import { useEffect } from "react";

export const SITE_NAME = "黑料网社";
export const SITE_ORIGIN = "https://ftldb.cn";

export interface PageMeta {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel: string, href: string) {
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function applyJsonLd(data?: Record<string, unknown> | Record<string, unknown>[]) {
  const existing = document.getElementById("page-jsonld");
  if (existing) existing.remove();
  if (!data) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "page-jsonld";
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

export function useDocumentMeta(meta: PageMeta) {
  const { title, description, keywords, path, ogType = "website", jsonLd } = meta;

  useEffect(() => {
    const url = `${SITE_ORIGIN}${path}`;
    document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index, follow, max-image-preview:large");
    upsertLink("canonical", url);

    upsertMeta("property", "og:site_name", SITE_NAME);
    upsertMeta("property", "og:locale", "zh_CN");
    upsertMeta("property", "og:type", ogType);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);

    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    applyJsonLd(jsonLd);
  }, [title, description, keywords, path, ogType, jsonLd]);
}